<template>
  <div class="jlxk-view-container">
    <div class="list-container">
      <el-tabs
        v-model="currentList"
        v-show="expandFlag"
        @tab-click="handleChangeTab"
      >
        <el-tab-pane
          v-for="item in contentList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>
      <!-- 保证检索条件不重叠 -->
      <keep-alive>
        <List
          v-if="isNoPushList"
          ref="notPush"
          :class="{ 'jlxk-data-content-expand': expandFlag }"
          :nav-data="navData"
          :department-list="departmentList"
          :theme-data="themeData"
          :region-list="regionList"
          :categories="categories"
          :total="total"
          :empty="empty"
          :list-data="listData"
          @updateList="getFindUploadData"
          @changeSelected="changeSelected"
          @updateExpand="updateExpand"
          @handleCommand="handleCommand"
        />
      </keep-alive>
      <keep-alive>
        <List
          v-if="!isNoPushList"
          ref="pushed"
          :class="{ 'jlxk-data-content-expand': expandFlag }"
          :nav-data="navData"
          :department-list="departmentList"
          :theme-data="themeData"
          :region-list="regionList"
          :categories="categories"
          :total="total"
          :empty="empty"
          :list-data="listData"
          :is-show-conditon="false"
          @updateList="getFindUploadData"
          @changeSelected="changeSelected"
          @updateExpand="updateExpand"
        />
      </keep-alive>
    </div>
    <el-tabs
      v-model="currentTab"
      class="tag-tab-conditon"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <components
            v-if="currentTab === item.name"
            :is="item.name"
            :ref="item.name"
            :current-item="currentItem"
            :top-data-code="topDataCode"
            :is-show-operate="isNoPushList"
            :btn-arr="detailArr"
            :is-can-add="false"
            :is-can-push="true"
            :is-can-alter-detail="false"
            :is-show-review-oper="false"
            @handleCommand="handleCommand"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <sureDialog
      ref="sureDialog"
      class="sureDialog"
      :is-show-footer="isShowOper"
      width="450px"
      :is-tran-cancel="true"
      @dialogSure="getUploadXiaokangByIds"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ tips }}
      </div>
    </sureDialog>
  </div>
</template>

<script>
import { toTopAnimation } from '@common/util.js'
import List from './components/list'
import detail from '@views/jlxk/dataView/components/detail'
import tag from '@views/jlxk/dataView/components/tag'
import sureDialog from '@components/dialog/cyDialogCommon'
import jlxkAPIS from '@apis/jlxk'
import APIS from '@apis/settings'
export default {
  name: 'Editor',
  components: {
    List,
    detail,
    tag,
    sureDialog
  },
  props: {},
  data() {
    return {
      navData: [],
      departmentList: [],
      themeData: [],
      regionList: [],
      categories: [],
      currentTab: 'detail',
      tabList: [
        {
          name: 'detail',
          label: '详情'
        },
        {
          name: 'tag',
          label: '标签'
        }
      ],
      currentList: 'notPush',
      contentList: [
        {
          name: 'notPush',
          label: '待推送列表'
        },
        {
          name: 'pushed',
          label: '已推送列表'
        }
      ],
      currentId: '',
      total: 0,
      listData: [],
      empty: '',
      active: 0,
      expandFlag: true,
      isShowOper: true,
      isDetail: false,
      detailArr: [
        {
          id: 'push',
          label: '推送',
          icon: 'jlxk-data-view-push'
        }
      ],
      checkedLists: []
    }
  },
  computed: {
    currentItem() {
      return this.listData[this.active]
    },
    topDataCode() {
      if (!this.currentItem) return ''
      let id = this.currentItem.topDataCategoryId
      let obj = this.navData.filter(item => String(item.id) === String(id))[0]
      return (obj && obj.code) || ''
    },
    currentIndex() {
      return this.$store.state.currentIndex
    },
    dataArr() {
      return this.listData.map(item => item.id)
    },
    isNoPushList() {
      return this.currentList === 'notPush'
    },
    checkedLen() {
      return this.checkedLists.length
    },
    tips() {
      return this.isDetail ? '是否推送该条数据？' : this.isShowOper ? `您已勾选${this.checkedLen}条数据，是否推送？` : '请选择稿件'
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
    this.getNavList()
    this.getCatDepartment()
    this.getCatTheme()
    this.getRegionsList()
    this.getCategories()
  },
  methods: {
    // 数据分类列表
    async getNavList() {
      let { status, data } = await APIS.postCatCategory()
      if (status === 0 && data && data.length !== 0) {
        this.navData = data
        this.getFindUploadData()
      } else {
        this.navData = []
      }
    },
    // 获取机构列表
    async getCatDepartment() {
      let { status, data } = await jlxkAPIS.postDepartmentTree()
      if (status === 0 && data && data.length !== 0) {
        this.departmentList = data
      }
    },
    // 主题列表
    async getCatTheme() {
      let { status, data } = await APIS.postCatTheme()
      if (status === 0 && data && data.length !== 0) {
        this.themeData = [{ name: '全部', id: '', children: [] }].concat(data)
      }
    },
    // 地域列表
    async getRegionsList() {
      let { status, data } = await jlxkAPIS.postRegionsList({
        data: { pid: 86, subLevel: 2 }
      })
      if (status === 0 && data && data.length !== 0) {
        this.regionList = [{ name: '全国', id: '86', children: [] }].concat(
          data
        )
      }
    },
    // 领域列表
    async getCategories() {
      let { status, data } = await jlxkAPIS.postCategories()
      if (status === 0 && data && data.length !== 0) {
        this.categories = [{ name: '全部', id: '' }].concat(data)
      } else {
        this.categories = []
      }
    },
    // 获取数据列表
    async getFindUploadData() {
      this.empty = ''
      let params = this.$refs[this.currentList].getParams()
      params = Object.assign({}, params, { isUploadSuccess: this.isNoPushList ? 0 : 1 })
      let { status, data } = await jlxkAPIS.postFindUploadData({ data: params })
      if (status === 0 && data && data.result && data.result.length !== 0) {
        this.total = data.total
        this.listData = data.result.map((item, index) => {
          return {
            id: item.id,
            topicIndex: (params.page - 1) * params.pagesize + index + 1,
            publisher: item.publisher,
            author: item.author,
            status: item.oristatus,
            coverpicurl:
              String(item.articleTypeId) === '3'
                ? ''
                : item.coverPicUrl
                  ? item.coverPicUrl.split(';')[0]
                  : item.attachments && item.attachments.length !== 0
                    ? item.attachments[0].s_uri
                    : '',
            attachments: item.attachments,
            originalpicurl: item.originalPicUrl,
            zzsrc: item.zzsrc,
            description: item.description,
            title: item.title,
            articletypeid: item.articleTypeId,
            pubdate: item.pubdate,
            topCategory: item.topCategory,
            involvePerson: item.involvePerson,
            province: item.province,
            city: item.city,
            county: item.county,
            village: item.village,
            location: item.location,
            region: item.province + item.city + item.county + item.village,
            department: item.department,
            totalEpisodeNumber: item.totalEpisodeNumber,
            episodeNumber: item.episodeNumber,
            created: item.created,
            topTopic: item.topTopic,
            topTopicId: item.topTopicId,
            secTopic: item.secTopic,
            secTopicId: item.secTopicId,
            theme: item.topTopic + item.secTopic,
            keyWords: item.keyWords,
            isAppraise: item.isAppraise,
            hasPic: item.hasPic,
            isSensitive: item.isSensitive === 1 ? '是' : '否',
            nation: item.nation,
            topDataCategoryId: item.topDataCategoryId,
            contentAttribute: item.contentAttribute,
            categoryName: `${item.topDataCategory} -> ${item.secDataCategory}`
          }
        })
        this.active = 0
        this.$refs[this.currentList].$refs.list.active = 1
        this.$nextTick(() => {
          this.$refs[this.currentList].handleCheckedChange()
        })
        if (document.querySelector('.jlxk-view-container .jlxk-data-content .list')) {
          toTopAnimation('.jlxk-view-container .jlxk-data-content .list')
        }
        if (document.querySelector('.data-view-detail-container .detail-container')) {
          toTopAnimation('.data-view-detail-container .detail-container')
        }
      } else {
        this.empty = '当前未查询到任何数据'
        this.listData = []
        this.total = 0
      }
    },
    async getUploadXiaokangByIds () {
      let params = {
        ids: this.checkedLists.join(',')
      }
      let { status, data } = await jlxkAPIS.postUploadXiaokangByIds({ data: params })
      let error = (data.error && data.error.split(',')) || []
      let illegal = (data.illegal && data.illegal.split(',')) || []
      let errorLen = error.length + illegal.length
      if (status === 0 && data && data.success) {
        let successlen = data.success.split(',').length
        let message = errorLen === 0 ? `已成功推送${successlen}条` : `已成功推送${successlen}条，失败${errorLen}条`
        this.global_.handleMessageTips(message, 'success')
        this.$refs[this.currentList].resetCheck()
        this.getFindUploadData()
      } else {
        this.global_.handleMessageTips(`推送失败${errorLen}条`, 'error')
      }
      this.$refs.sureDialog.cyDialogCommon = false
    },
    // 切换选中稿件
    changeSelected(index) {
      this.active = index
      if (document.querySelector('.data-view-detail-container .detail-container')) {
        toTopAnimation('.data-view-detail-container .detail-container')
      }
    },
    // 操作：推送
    handleCommand(value) {
      this.isDetail = value.isDetail || false
      this.checkedLists = this.isDetail ? [value.id] : this.$refs[this.currentList].checkedLists
      this.isShowOper = this.isDetail ? true : this.checkedLists !== 0
      this.$refs.sureDialog.cyDialogCommon = true
    },
    updateExpand(val) {
      this.expandFlag = val
    },
    // 切换tab
    handleChangeTab() {
      this.$nextTick(() => {
        this.getFindUploadData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-view-container {
  display: flex;
  .list-container {
    display: flex;
    width: 768px;
    flex-direction: column;
    margin: 0 12px 0 0;
    @extend .comBackground;
    /deep/ .el-tabs {
      .el-tabs__header {
        margin: 0 7px 0 13px;
        .el-tabs__nav-scroll {
          padding: 0 10px 0 13px;
        }
        .el-tabs__nav-wrap:after{
          height:1px;
          background-color:#EDF0F7;
        }
        .el-tabs__item {
          line-height: 42px;
          padding: 0 60px 0 0;
        }
      }
    }
    /deep/ .jlxk-data-content {
      position: relative;
      &.jlxk-data-content-expand {
        height: calc(100vh - 135px);
      }
      i.condition-expand-icon.icon-arrow-up {
        top: -21px;
      }
    }
  }
  /deep/ .el-tabs.tag-tab-conditon {
    width: 440px;
    @extend .comBackground;
    .el-tabs__header {
      width: 100%;
      margin: 0;
      background: #ffffff;
      border-radius: 5px 5px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
        }
        &::after {
          height: 1px;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
    .el-tabs__content {
      overflow: initial;
      background-color: #fff;
      .data-view-detail-container {
        .detail-container {
          padding: 15px 20px 5px;
          height: calc(100vh - 192px);
          overflow-y: auto;
        }
      }
    }
  }
  /deep/ .sureDialog {
    .delete-icon-box {
      width: 60px;
      height: 60px;
      background-color: #f3c245;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
    }
    .delete-text {
      text-align: center;
    }
    .el-dialog__footer {
      margin: 0;
    }
  }
}
</style>
